import { translateBlockValue } from 'i18n';

/**
 * Capitalizes the first and last word of a sentence
 * @param {string} input - The input sentence
 * @returns {string} - The capitalized sentence
 */
const capitalizeFirstAndLastWords = (input: string) => {
    const words = input.split(' ');
    // Capitalize the first word
    words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
    // Capitalize the last word
    const lastIndex = words.length - 1;
    words[lastIndex] =
        words[lastIndex].charAt(0).toUpperCase() + words[lastIndex].slice(1);
    return words.join(' ');
};

export const getProjectionVentilationReadableValue = (
    input: string,
    softwares: Set<string>,
) => {
    const readable = translateBlockValue(input, true, softwares);
    return capitalizeFirstAndLastWords(readable);
};
